/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ApiService, Cart } from '@midas/shared/common';
import { TranslocoModule } from '@ngneat/transloco';
import { map, Observable } from 'rxjs';
import { IQuerySelect, PagedResult } from '../ui-query-select';

@Component({
  selector: 'midas-ui-cart-query-select',
  templateUrl: './ui-cart-query-select.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
    TranslocoModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiCartQuerySelectComponent),
      multi: true,
    },
  ],
})
export class UiCartQuerySelectComponent extends IQuerySelect<Cart> {
  constructor(private api: ApiService, protected _change: ChangeDetectorRef) {
    super(_change);
  }

  getItemsBySearchString(
    searchString?: string | null,
    startingIndex = 0,
    numberOfRecords = 10,
  ): Observable<PagedResult<Cart>> {
    return this.api
      .get<{ count: number; carts: Cart[] }>('/cart', {
        startingIndex,
        numberOfRecords,
        searchString,
      })
      .pipe(map((res) => ({ count: res.count, items: res.carts })));
  }

  getItemsByIds(ids: number[]): Observable<Cart[]> {
    return this.api
      .get<{ count: number; carts: Cart[] }>('/cart', {
        startingIndex: 0,
        numberOfRecords: 5,
        ids: ids,
      })
      .pipe(map((res) => res.carts));
  }
}
